<template>
<ion-app main>
  <ion-header>
    <ion-toolbar color="light">
      <ion-buttons slot="start">
        <ion-button @click="openEnd">
          <ion-icon name="menu"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Importar</ion-title>
    </ion-toolbar>
    <ion-progress-bar v-if="guardables>0" :value="guardados/guardables" />
  </ion-header>
  <ion-content class="ion-padding">
    <ion-list>
      <ion-item>
        <ion-note slot="start">1</ion-note>
        <ion-label>Tipo de catálogo</ion-label>
        <ion-select :value="tipoCatalogo" v-on:ionChange="tipoCatalogo=$event.detail.value">
          <ion-select-option v-for="(catalogo,indice) in mapaCatalogos" :key="indice">{{indice}}</ion-select-option>
        </ion-select>
      </ion-item>
      <label for="csv" v-if="tipoCatalogo!=''">
        <ion-item>
          <ion-note slot="start">2</ion-note>
          <ion-label>Clic para seleccionar archivo CSV</ion-label>
          <ion-note slot="end">
            <i class="icon ion-ios-cloud-upload"></i>
          </ion-note>
        </ion-item>
        <input class="hidden" type="file" id="csv" name="csv" @change="subirCSV">
      </label>
    </ion-list>
    <table class="importable" v-if="objetos.length>0">
      <thead>
        <tr>
          <th>Campo</th>
          <th v-for="i in 5" :key="i">{{objetos[0][i]}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(clave,indice) in objetos[0]" :key="indice">
          <td>{{objetos[0][indice]}} {{indice}} <br />
            <select v-model="campos[indice]">
              <option v-for="m in mapaCatalogos[tipoCatalogo]" :key="m">{{m}}</option>
            </select>
          </td>
          <td v-for="u in 5" :key="u">{{objetos[u][indice]}}</td>
        </tr>
      </tbody>
    </table>
    <ion-fab horizontal="end" vertical="bottom" slot="fixed">
      <ion-fab-button color="medium" @click="guardar" :disabled="objetos.length==0 || guardando">
        <i class="icon icon-lg ion-ios-save"></i>
      </ion-fab-button>
    </ion-fab>
  </ion-content>
  <ion-footer>
    <ion-progress-bar v-if="guardables>0" :value="guardados/guardables" />
  </ion-footer>
</ion-app>
</template>
<style>
.importable {
  width: 100%;
  text-align: left;
}

.importable th {
  border: 1px solid #cccccc;
}

.importable th,
.importable td {
  padding: 3px;
}
</style>
<script>
import Api from '@/components/Api/Api'
import sha1 from 'sha1'
export default {
  name: 'CatalogoUsuarios',
  data() {
    return {
      probando: false,
      yo: Api.fetchLocal('cmms.yo') || {},
      guardados: 0,
      guardables: 0,
      guardando: false,
      tipoCatalogo: 'equipo',
      mapaCatalogos: {
        branding: ['nombre', 'razonSocial', 'email', 'telefono', 'direccion', 'sitioWeb'],
        cliente: ['nombre', 'alias', 'email', 'direccion', 'representante', 'rfc'],
        directorio: ['nombre', 'email', 'password', 'rol'],
        equipo: ['alias', 'marca', 'modelo', 'cliente', 'nombreContrato', 'sn', 'area', 'subarea', 'tipo']
      },
      campos: [],
      objetos: [],
      mapaTabla: [],
      csvProcesable: null
    }
  },
  methods: {
    openEnd() {
      Api.$emit('open-menu')
    },
    async subirCSV() {
      let csvProcesable = await Api.upload('#csv', 'binario')
      csvProcesable = csvProcesable
        .replace(/%20/g, ' ')
        .replace(/Ã¡/g, 'á')
        .replace(/É/g, "é")
        .replace(/Ã©/g, "é")
        .replace(/Ã­/g, 'í')
        .replace(/Ã³/g, 'ó')
        .replace(/%2C/g, ',')
        .replace(/%24/g, "\$")
        .replace(/%28/g, "(")
        .replace(/%29/g, ")")
        .replace(/Ã±/g, 'ñ')
      this.objetos = (csvProcesable.split('\n'))
        .map(renglon => renglon.split(','))
      console.log('csvProcesable?', csvProcesable.length, this.objetos.length)
      this.tratarDeAsignarCamposAutomaticamente()
    },
    tratarDeAsignarCamposAutomaticamente() {
      for (let header in this.objetos[0])
        for (let campo of this.mapaCatalogos[this.tipoCatalogo])
          if (this.objetos[0][header].toLowerCase().startsWith(campo))
            this.campos[header] = campo
      console.log("Automatico?", this.campos)
    },
    async guardar() {
      //  mapear
      this.guardando = true
      let objetosGuardables = []
      this.guardables = objetosGuardables.length
      this.guardados = 0
      for (let o of this.objetos) {
        let objetoGuardable = {
          importado: new Date().getTime(),
          idAutor: this.yo._id
        }
        for (let c in this.campos) {
          //console.log("Asignar", (o.nombre || o.sn), c, o[c], this.campos[c])
          objetoGuardable[this.campos[c]] = o[c]
          // Clientes del equipo
          if (this.tipoCatalogo == 'equipo') {
            if (this.campos[c] == 'cliente' && objetoGuardable[this.campos[c]] && objetoGuardable[this.campos[c]] != '') {
              let cliente = await Api.find('cliente', ['nombre,eq,' + objetoGuardable[this.campos[c]]])
              if (cliente && cliente[0])
                cliente = cliente[0]
              if (cliente && cliente._id) {
                console.log("Encontrado cliente", cliente.nombre)
              } else if (objetoGuardable.cliente && typeof objetoGuardable.cliente == 'string') {
                cliente = {
                  email: sha1(objetoGuardable.cliente).substring(0, 8) + '@local',
                  password: sha1(Math.random()),
                  nombre: objetoGuardable.cliente,
                  alias: objetoGuardable.cliente,
                  importado: new Date().getTime(),
                  idAutor: this.yo._id
                }
                console.log("Cliente nuevo", cliente)
                if (!this.probando) {
                  cliente = await Api.save('cliente', cliente)
                  await Api.wait(250)
                }
                toast("Nuevo cliente: " + cliente.nombre)
              }
              objetoGuardable.idCliente = cliente._id
            }
          }
        }
        //console.log("objetoGuardable?", objetoGuardable)
        if ((objetoGuardable.nombre || '') + (objetoGuardable.sn || '') != '')
          objetosGuardables.push(objetoGuardable)
      }
      // Existentes
      let existentes = await Api.get(this.tipoCatalogo)
      // Guardar
      console.log('guardables', objetosGuardables)
      this.guardables = objetosGuardables.length
      if (!this.probando) {
        for (let o of objetosGuardables)
          if ((o.nombre || '') + (o.sn || '') != '') {
            // Averiguar si no existe
            let existente = false
            for (let e of existentes)
              if (e.sn == o.sn || (e.nombre == o.nombre && o.nombre && o.nombre != ''))
                existente = true
            if (existente) {
              toast("Objeto existente: " + o.sn || o.nombre)
              await Api.wait(200)
            } else {
              await Api.save(this.tipoCatalogo, o)
            }
            this.guardados++
          }
        //
        toast("Guardado")
        await Api.wait()
        window.location.reload()
      }
    }
  },
  watch: {
    campos: function(a) {
      console.log("$watch campos", a)
    }
  },
  async mounted() {
    this.guardados = 0
    this.guardables = 0
    console.log("Importar mounted")
  }
}
</script>
